<!--
 * @Author: your name
 * @Date: 2021-03-12 13:35:58
 * @LastEditTime: 2021-08-09 16:13:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\components\swiper.vue
-->
<template>
  <div class="container-swiper">
    <swiper
      :options="swiperOption"
      class="swiper-container swiper-pagination1"
      ref="mySwiper"
    >
      <!-- 添加的图片,src中存放图片路径 -->
      <swiper-slide v-for="(item, Index) in starItemList" :key="Index">
        <div class="swiper_item-wrap">
          <div class="swiper_item">
            <div
              class="item product productBtn"
              :data-starId="item.id"
              :data-index="Index"
              :data-item="JSON.stringify(item)"
            >
              <div class="img">
                <img class="auto-img" :src="item.imageUrl" />
              </div>
              <div class="name">
                {{ item.title }}
              </div>
              <div class="vice_name" v-if="item.seoDescription">
                {{ item.seoDescription }}
              </div>
              <!-- 按钮 -->
              <!-- <div
                class="understand_now "
                :data-starId="item.id"
                :data-index="Index"
                :data-item="JSON.stringify(item)"
              >
                {{ lange == "Ch" ? "立即了解" : "すぐにわかる" }}
              </div> -->
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div
      class="swiper-button-prev layout_vertica_center web"
      slot="button-prev"
    >
      <i class="el-icon-arrow-left" style="font-weight: bold !important"></i>
    </div>
    <div
      class="swiper-button-next layout_vertica_center web"
      slot="button-next"
    >
      <i class="el-icon-arrow-right" style="font-weight: bold !important"></i>
    </div>
  </div>
</template>

<script>
//局部引入swiper插件
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "BestCarousel",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: ["starItemList"],
  // 定义属性
  data() {
    return {
      banner: [],
      swiperOption: {
        // 参数选项,显示小点
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        // 箭头配置
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        spaceBetween: 25,
        // slidesPerView: 3,
        slidesPerGroup: 3,
        //循环
        loop: true,
        //自动播放的相关设置
        // autoplay: {
        //   disableOnInteraction: true,
        //   delay: 6000,
        // },
        slidesPerView: 3,
        on: {
          // touchStart: (e) => {
          //   if (
          //     document.querySelectorAll(".product")[
          //       e.clickedIndex
          //     ]
          //   ) {
          //     const id = document
          //       .querySelectorAll(".product")
          //       [e.clickedIndex].getAttribute("data-starId");
          //     const item = document
          //       .querySelectorAll(".product")
          //       [e.clickedIndex].getAttribute("data-item");
          //     const index = document
          //       .querySelectorAll(".product")
          //       [e.clickedIndex].getAttribute("data-index");
          //     this.onStarItemPage(id, item, index);
          //   }
          // },
          click: (e) => {
            if (document.querySelectorAll(".productBtn")[e.clickedIndex]) {
              const id = document
                .querySelectorAll(".productBtn")
                [e.clickedIndex].getAttribute("data-starid");
              const item = document
                .querySelectorAll(".productBtn")
                [e.clickedIndex].getAttribute("data-item");
              const index = document
                .querySelectorAll(".productBtn")
                [e.clickedIndex].getAttribute("data-index");
              this.onStarItemPage(id ? id : 0, item, index);
            }
          },
        },
      },
    };
  },
  computed: {},
  // 监控data中的数据变化
  watch: {
    starItemList(val) {
      if (val) {
        this.swiperOption.loop = val.length > 2 ? true : false;
      }
    },
  },
  // 方法集合
  methods: {
    onStarItemPage(id, item, index) {
      this.$router.push({
        name: "StarItem",
        query: {
          id: id,
          detail: item,
          isDetail: true,
          index: `2-${index}`,
        },
      });
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang='less' scoped>
.container-swiper {
  max-width: 1440px;
  min-width: 1240px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  .swiper-container {
    width: calc(100% - 100px);
    margin: 0px auto;
    position: relative;
    .swiper_item{
      cursor: pointer;
    }
    /deep/.swiper {
      &-slide {
        box-sizing: border-box;
        
      }
      .swiper-wrapper>div:nth-child(3n) {
        margin-right: 0 !important;
      }
      &-pagination {
        width: 100%;
        height: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        z-index: 1;
        &-bullet {
          background: #fff !important;
          opacity: 1;
          margin: 0 5px;
        }
        &-bullet-active {
          background: #876d4b !important;
        }
        .my-bullet {
          border-radius: 50%;
          width: 4px;
          height: 4px;
          margin: 4px;
          background: #000000;
          display: block;
        }
        .my-bullet-active {
          display: block;
          background: #000000;
          width: 10px;
          height: 4px;
          border-radius: 2px;
        }
      }
      &-pagination-bullet {
        border-radius: 50%;
        &-active {
          background: #fff;
        }
      }
     &_item-wrap{
        padding:0 15px;
       
     }
      &_item {
        display: flex;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        border: solid 1px #dedede;
        .item {
          width: 100%;
          min-height: 500px;//605px;
          text-align: center;
          font-size: 20px;
          font-weight: 400;
          margin: 0 auto;
          .img {
            width: 100%;
            height: 398px;
            overflow: hidden;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
          }
          .name {
            color: #212121;
            display: inline-block;
            line-height: 26px;
            height: 54px;
            overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;
          }
          .vice_name {
            width: 100%;
            font-size: 18px;
            color: #878787;
            margin: 12px 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: 200;
            overflow: hidden;
            word-break: break-all;
          }
          .understand_now {
            // display: none;
            width: 150px;
            height: 34px;
            // background: #faecc7;
            font-size: 15px;
            font-weight: 400;
            color: #53524e;
            text-align: center;
            line-height: 32px;
            margin: 15px auto 40px;
            border: solid 1px #53524e;
            border-radius: 30px;
            cursor: pointer;
          }
        }
      }
    }
  }
  // .swiper-container:hover {
  //   .swiper-button-prev,
  //   .swiper-button-next {
  //     display: block;
  //   }
  // }
  // .swiper-slide a {
  //   display: block;
  // }

  .swiper-button {
    &-prev {
      left: 0px;
    }
    &-next {
      right: 0px;
    }
    &-prev,
    &-next {
      width: 36px;
      height: 36px;
      border: 2px solid #212121;
      border-radius: 50%;
      z-index: 1;
      cursor: pointer;
      text-align: center;
      line-height: 36px;
      font-size: 24px !important;

      color: #212121;
      // display: none;
    }
  }
}
</style>
